import { render, staticRenderFns } from "./TargetsList.vue?vue&type=template&id=584dbd73&scoped=true&"
import script from "./TargetsList.vue?vue&type=script&lang=js&"
export * from "./TargetsList.vue?vue&type=script&lang=js&"
import style0 from "./TargetsList.vue?vue&type=style&index=0&id=584dbd73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584dbd73",
  null
  
)

export default component.exports